import React, { useEffect } from 'react';
import { T } from 'shared/helper/translate';
import { validators } from 'shared/helper/form';
import ControlFromType from './ControlFromType';
var notEmpty = validators.notEmpty;
var questionIsDisplayed = function questionIsDisplayed(question) {
  var answers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var questionsRequiringPreviousSelection = arguments.length > 2 ? arguments[2] : undefined;
  if (question.displayed) {
    return true;
  }
  var previousQuestion = questionsRequiringPreviousSelection[question.label] || null;
  if (!previousQuestion) {
    return false;
  }
  var matchingAnswer = answers[previousQuestion.questionLabel] || null;
  if (!matchingAnswer) {
    return false;
  }
  var matchingAnswers = Array.isArray(matchingAnswer) ? matchingAnswer : [matchingAnswer];
  return matchingAnswers.indexOf(previousQuestion.choice) !== -1;
};
var Question = function Question(_ref) {
  var answers = _ref.answers,
    question = _ref.question,
    questionsRequiringPreviousSelection = _ref.questionsRequiringPreviousSelection,
    name = _ref.name,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    methods = _ref.methods,
    id = _ref.id;
  var displayed = questionIsDisplayed(question, answers, questionsRequiringPreviousSelection);
  useEffect(function () {
    if (!displayed) {
      methods.setValue("answers[".concat(question.label, "]"), '');
    }
  }, [displayed]);
  if (!displayed) {
    return null;
  }
  var idAttr = id || null;
  var additionalProps = required ? {
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    validators: {
      notEmpty: notEmpty
    }
  } : {};
  var styles = question.styles ? question.styles : {};
  var options = question.choices.map(function (choice) {
    return {
      followUpQuestionIdentities: choice.followUpQuestionIdentities,
      label: /*#__PURE__*/React.createElement(T, {
        source: choice.label
      }),
      value: choice.label
    };
  });
  return /*#__PURE__*/React.createElement(ControlFromType, {
    label: question.label,
    messages: additionalProps.messages,
    name: name,
    options: options,
    styles: styles,
    type: question.type,
    validators: additionalProps.validators,
    id: idAttr
  });
};
export default Question;